const workerListGridConfig = {
    columns: [
        {
            id: 1,
            width: 230,
            selector: 'egn',
            name: 'ЕГН',
            sequenceNumber: 4,
            type: 'string'
        },
        {
            id: 2,
            width: 250,
            selector: 'firstName',
            name: 'Име',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 3,
            width: 250,
            selector: 'middleName',
            name: 'Презиме',
            sequenceNumber: 2,
            type: 'string'
        },
        {
            id: 4,
            width: 250,
            selector: 'lastName',
            name: 'Фамилия',
            sequenceNumber: 3,
            type: 'string'
        },
        {
            id: 5,
            width: 318,
            selector: 'professionName',
            name: 'Професия',
            sequenceNumber: 5,
            type: 'string',
            filterComponent: 'TeamProfessionDropdown'
        },
        {
            id: 6,
            width: 200,
            selector: 'generalStatusName',
            name: 'Статус',
            sequenceNumber: 5,
            type: 'string',
            filterComponent: 'GeneralStatusDropdown'
        },
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 500,
        filterable: true,
        selectableColumn: {
            show: true,
            icon: 'fa fa-user',
            width: 90
        }
    }
};

export default workerListGridConfig;
